import { JSConn } from "@/utilities/js-conn";

export default {
  name: "workOrderLots",
  data() {
    return {};
  },
  computed: {
    workOrderLots: function() {
      return this.$store.getters.workOrderLots;
    },
    workOrder: function() {
      return this.$store.getters.workOrder;
    },
  },
  methods: {
    deleteLot(lot) {
      const jsConn = new JSConn();
      jsConn.formParams = lot;
      this.$store.dispatch("deleteWorkOrderLot", jsConn).then(() => {
        this.$emit("lotsChanged");
      });
    },
  },
};
